import {
  CalendarType,
  VisitCardLineStyleDto,
  VisitCardSettingsDto,
} from '@lmt/shared-types';
import i18next from 'i18next';
import * as yup from 'yup';

function t(value: string, options?: any) {
  return i18next.t(
    `translation:calendar.visit_card_settings.errors.${value}` as any,
    options,
  );
}

export const lineStylesYupSchema: yup.SchemaOf<Partial<VisitCardLineStyleDto>> =
  yup.object({
    position: yup.number().required(),
    expression: yup.string().required(() => t('required')),
    fontSize: yup
      .number()
      .required(() => t('required'))
      .typeError(() => t('incorrect'))
      .max(36, () => t('max_number', { maxNumber: 36 }))
      .min(10, () => t('min_number', { minNumber: 10 })),
    paddingTop: yup
      .number()
      .required(() => t('required'))
      .typeError(() => t('incorrect'))
      .max(40, () => t('max_number', { maxNumber: 40 }))
      .min(2, () => t('min_number', { minNumber: 2 })),
    isBold: yup.boolean(),
  });

export function validateField(key: string, value: any): string | undefined {
  try {
    yup.reach(lineStylesYupSchema, key).validateSync(value);
    return undefined;
  } catch (error: any) {
    return error.message as string;
  }
}

export function getVisitCardStylesForCalendarType(
  calendarType: CalendarType,
  settings?: VisitCardSettingsDto,
): VisitCardLineStyleDto[] {
  switch (calendarType) {
    case CalendarType.Day:
      return settings?.dayLineStyles ?? [];
    case CalendarType.Week:
      return settings?.weekLineStyles ?? [];
    case CalendarType.Month:
      return settings?.monthLineStyles ?? [];
    default:
      return [];
  }
}
